import { bool, func, instanceOf, string, oneOfType, object } from 'prop-types';
import { branch, compose, renderComponent } from 'recompose';

import glossaryPropTypes from './glossaryPropTypes';
import ErrorContent from 'components/Error/ErrorContent/ErrorContent';
import GlossaryWrapper from './GlossaryWrapper';
import { GlossaryTitle, Toolbar, CloseButton } from './Glossary.style';
import { ReactComponent as CloseIcon } from 'icons/icon-close-large.svg';
import BrowseGlossary from 'components/Glossary/Browse/BrowseGlossary';

/**
 * GlossaryOverview page that renders a list of groups and topics as links to specific Glossary pages
 */
const GlossaryOverview = ({ data, modal, hide, loading }) => {
  return (
    <GlossaryWrapper title="Glossary" modal={modal} loading={loading}>
      <Toolbar>
        <GlossaryTitle>Glossary</GlossaryTitle>
        {modal && (
          <CloseButton onClick={hide} data-pw="ModalCloseButton">
            <CloseIcon />
          </CloseButton>
        )}
      </Toolbar>
      <BrowseGlossary data={data} modal={modal} />
    </GlossaryWrapper>
  );
};

GlossaryOverview.propTypes = {
  /** Is this a modal? */
  modal: bool.isRequired,
  /** Glossary data returned by the API */
  data: glossaryPropTypes,
  /** The action to perform when you want to close the modal. Only required when modal is set to true */
  hide: func,
  /** Boolean indicating if this component is in loading state */
  loading: bool.isRequired,
};

const ErrorDisplay = ({ modal, error, errorInfo }) => (
  <ErrorContent
    error={error}
    errorInfo={errorInfo}
    showRefreshButton={!modal}
  />
);

ErrorDisplay.propTypes = {
  /** An instance of the native Error object */
  error: instanceOf(Error),
  /** An object with additional error information, like a stack trace, or request headers. */
  errorInfo: oneOfType([object, string]),
  /** Indicates if you want to show the close icon */
  modal: bool.isRequired,
};

const showError = (error) => branch(error, renderComponent(ErrorDisplay));
const enhance = compose(showError(({ loading, error }) => !loading && error));

const EnhancedGlossaryOverview = enhance(GlossaryOverview);

EnhancedGlossaryOverview.propTypes = {
  /** Glossary data returned by the API */
  data: glossaryPropTypes,
  /** An instance of the native Error object */
  error: instanceOf(Error),
  /** An object with additional error information, like a stack trace, or request headers. */
  errorInfo: oneOfType([object, string]),
  /** The action to perform when you want to close the modal. Only required when modal is set to true */
  hide: func,
  /** Boolean indicating if this component is in loading state */
  loading: bool.isRequired,
  /** Indicates if you want to show the close icon */
  modal: bool.isRequired,
};

export default EnhancedGlossaryOverview;
